import axios from "axios";
import qs from "qs";

const oauthUrl = `${process.env.REACT_APP_SHADOW_API_BASE_URL}/${
  process.env.REACT_APP_SHADOW_API_CLIENT_TOKEN
}/oauth/v2/token`;
const oauthClientId = process.env.REACT_APP_OAUTH_CLIENT_ID;
const oauthClientSecret = process.env.REACT_APP_OAUTH_CLIENT_SECRET;
let tokenPromise;

const invalidateToken = () => {
  tokenPromise = null;
};

const fetchToken = () => {
  if (tokenPromise) {
    return tokenPromise;
  }

  const requestToken = axios.post(
    oauthUrl,
    qs.stringify({
      grant_type: "client_credentials",
      client_id: oauthClientId,
      client_secret: oauthClientSecret
    }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }
  );

  tokenPromise = requestToken.then(response => response.data).then(response => {
    setTimeout(() => invalidateToken(), response.expires_in * 0.9 * 1000);

    return response.access_token;
  });

  return tokenPromise;
};

export default fetchToken;



// WEBPACK FOOTER //
// ./src/shadow-client/axios/fetchToken.js